import {
    type SearchFilter,
    type SortModel
} from "@/lib/depict-client/types/api/ProductListingRequestV3"

export const sortConfig: { [key: string]: SortModel } = {
    _relevance: {
        field: "_relevance",
        order: "desc",
        meta: {
            title: "Recommended",
            values: ["desc"],
            names: ["Recommended"]
        }
    },
    sale_price_desc: {
        field: "sale_price",
        order: "desc",
        meta: {
            title: "Price, high to low",
            values: ["desc"],
            names: ["Price, high to low"]
        }
    },
    sale_price_asc: {
        field: "sale_price",
        order: "asc",
        meta: {
            title: "Price, low to high",
            values: ["asc"],
            names: ["Price, low to high"]
        }
    },
    product_timestamp: {
        field: "product_timestamp",
        order: "desc",
        meta: {
            title: "Newest first",
            values: ["desc"],
            names: ["Newest first"]
        }
    }
}

export const SIZE_FILTER_FIELD = "size"

const FILTER_OP_OVERRIDES: Record<string, SearchFilter["op"]> = {}

const DEFAULT_FILTER_OP: SearchFilter["op"] = "in"

export function getFilterOp(field: string): SearchFilter["op"] {
    return FILTER_OP_OVERRIDES[field] ?? DEFAULT_FILTER_OP
}
